import React, { useState } from "react";

import { Col, Row } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";

import Form from "../Form";

import "./styles.scss";

const Component = ({
  folder,
  actionCode,
  folderStatus,
  loading,
  onSubmit,
  onBack,
}) => {
  const { t } = useTranslation(NAME_SPACES.HOME);
  const [data, setData] = useState({});

  const _onSubmit = () => {
    onSubmit(data);
  };
  return (
    <div className={"cancel"}>
      <Form
        folder={folder}
        folderStatus={folderStatus}
        actionCode={actionCode}
        onChange={setData}
      />
      <Space h={32} />
      <Row gutter={[16, 24]} justify="space-between">
        <Col md={10} xs={24}>
          <Button
            fillWidth={true}
            text={t("BACK_FOLDER")}
            variant={"SECONDARY"}
            onClick={onBack}
          />
        </Col>
        <Col md={10} xs={24}>
          <Button
            fillWidth={true}
            loading={loading}
            text={t("CONFIRM_BUTTON")}
            onClick={_onSubmit}
          />
        </Col>
      </Row>
    </div>
  );
};

Component.propTypes = {
  folder: PropTypes.shape({
    extra: PropTypes.shape({
      workflow: PropTypes.object,
    }),
  }).isRequired,
  folderStatus: PropTypes.shape({
    processCode: PropTypes.string,
    statusCode: PropTypes.string,
  }).isRequired,
  actionCode: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
};
export default Component;
